import { useNumericIdFromURL } from "./use-numeric-id-from-url";

export const useApplicantId = () => useNumericIdFromURL("applicantId");
